import { Status, TableRow } from 'apps/shared/scripts/components';
import { SimpleInvoiceFragment } from 'apps/shared/scripts/graphql/fragments/InvoiceFragment.generated';
import {
  formatCurrency,
  formatDateYear,
  formatInvoiceNumber,
  formatInvoiceStatus,
} from 'apps/shared/scripts/utils';

type Props = SimpleInvoiceFragment;

const InvoiceItem = ({
  cardRecipient,
  currencyCode,
  id,
  invoiceNumber,
  status,
  transactionTimestamp,
  totals,
}: Props) => {
  return (
    <TableRow to={`/dashboard/billing/${id}`}>
      <th scope="row">{formatInvoiceNumber(invoiceNumber)}</th>
      <td>{cardRecipient}</td>
      <td>{formatDateYear(transactionTimestamp)}</td>
      <td>
        {currencyCode} {formatCurrency(totals.grandTotal)}
      </td>
      <td>
        <Status label={formatInvoiceStatus(status)} />
      </td>
    </TableRow>
  );
};

InvoiceItem.displayName = 'InvoiceItem';

export default InvoiceItem;
